import { Modal } from '@abyss/web/ui/Modal/Modal';

import {
  PDF_GENERATING_KEYFRAMES,
  PdfGeneratingContainer,
  PdfGeneratingText,
  PdfSpinner,
} from './PrintDirectoryPage.style';

export interface PrintPdfGeneratorProps {
  isPdfGenerating: boolean;
  generatingPdfTitle: string;
  generatingPdfMessage: string;
}

export const PrintPdfGenerator = (props: PrintPdfGeneratorProps) => {
  const { isPdfGenerating, generatingPdfTitle, generatingPdfMessage } = props;
  if (!isPdfGenerating) return null;

  return (
    <>
      <style>{PDF_GENERATING_KEYFRAMES}</style>
      <Modal
        data-testid="pdf-generating-modal"
        isOpen
        onClose={() => {}}
        title={generatingPdfTitle || 'Generating PDF...'}
      >
        <PdfGeneratingContainer>
          <PdfSpinner />
          <PdfGeneratingText>{generatingPdfMessage}</PdfGeneratingText>
        </PdfGeneratingContainer>
      </Modal>
    </>
  );
};
